<div class="payout-request-kpi-card">
  <div class="payout-request-kpi-card-content">
    <div class="payout-request-kpi-card-header">
      <span class="payout-request-kpi-card-title">{{ title }}</span>
    </div>
    <div class="payout-request-kpi-card-value-container">
      <span class="payout-request-kpi-card-value" [style.color]="valueColor">
        {{ getFormattedValue() }}
      </span>
    </div>
    <div class="payout-request-kpi-card-subtitle">
      <span>{{ subtitle }}</span>
    </div>
  </div>
</div>

